import { useQuery } from '@tanstack/react-query';
import { getTemporadas } from '../../services/temporadasService';

/**
 * Hook para obtener todas las temporadas
 * @param {object} options - Opciones de React Query
 */
export const useTemporadas = (options = {}) => {
  return useQuery({
    queryKey: ['temporadas'],
    queryFn: () => getTemporadas(null),
    staleTime: 30 * 60 * 1000, // 30 minutos (temporadas cambian poco)
    ...options,
  });
};

export default useTemporadas;
